import React, { useCallback, useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import IconTooltip from '../../../IconTooltip';
import { useSelectionBox } from '../context';
import SelectionBoxControl from '../SelectionBoxControl';

import styles from './SelectionBoxItem.module.scss';

const iconProps = { width: 24, height: 24 };

const SelectionBoxItem = ({ value, disabled, disabledReason, children }) => {
  const { selected, selectionType, hideSelectionControl, size, onChange } =
    useSelectionBox();

  const isActive = useMemo(() => {
    if (selectionType === 'radio') {
      return value === selected;
    } else if (selectionType === 'checkbox') {
      return selected.includes(value);
    }
  }, [value, selected, selectionType]);

  const handleOnClick = useCallback(() => {
    onChange(value);
  }, [value, hideSelectionControl]);

  return (
    <div className={styles.container}>
      <div
        role="radio"
        className={cx(styles.content, {
          [styles.active]: isActive,
          [styles.sizeSm]: size === 'sm',
          [styles.sizeLg]: size === 'lg',
          [styles.disabled]: disabled,
          [styles.hasReason]: disabled && !!disabledReason,
        })}
        onClick={handleOnClick}
      >
        <SelectionBoxControl value={value} />
        {children}
      </div>

      {disabled && disabledReason && (
        <div className={styles.disabledReason}>
          <IconTooltip
            place="right"
            iconProps={iconProps}
            tip={<span>{disabledReason}</span>}
          />
        </div>
      )}
    </div>
  );
};

SelectionBoxItem.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  children: PropTypes.node,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string,
};

export default SelectionBoxItem;
